import { connect } from 'react-redux';
import { getLocales, getNonDefaultLocales } from 'store/modules/company';
import PageStatus from '../components/PageList/PageStatus';

const mapStateToProps = state => ({
  languages: getLocales(state),
  nonDefaultLanguages: getNonDefaultLocales(state),
});

const mapDispatchToProps = {};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(PageStatus);
